import React, { useMemo, useState, useCallback, useEffect } from 'react';
import clsx from 'clsx';
import { LibraryOptionProps, LibrarySelectProps } from 'components/Select/type';
import { SelectIcon } from 'asset/images';
import {
  Button,
  Typography,
  Popper,
  Grow,
  Paper,
  ClickAwayListener,
  MenuList,
  makeStyles,
  Theme,
} from '@material-ui/core';
import { SortOptionsByLibrary, OrderByOptions } from 'commons/constants/KeyFlowConstants';
import OrderOptionsByLibrary from 'components/SelectOptions/OrderOptionsByLibrary';

const useStyles = makeStyles((theme: Theme) => ({
  sortOptionButton: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '165px',
    border: '1px solid #d5d5d5',
    borderRadius: 0,
    margin: '0 12px 0 0',
    [theme.breakpoints.down('md')]: {
      width: '142px',
    },
  },
  popper: {
    zIndex: theme.zIndex.tooltip,
  },
  paper: {
    width: '165px',
    borderRadius: 0,
    [theme.breakpoints.down('md')]: {
      width: '142px',
    },
  },
  ellipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

function Option({ name, value, onSelect }: LibraryOptionProps) {
  const onClick = useCallback(() => {
    onSelect({ value });
  }, [onSelect, value]);
  return (
    <div key={value} onClick={onClick}>
      {name}
    </div>
  );
}

function LibrarySelect({ asc, sort, onChangeAsc, onChangeSort }: LibrarySelectProps) {
  const classes = useStyles();

  const [button, setButton] = useState<null | HTMLButtonElement>(null);
  const isOpen = useMemo(() => Boolean(button), [button]);

  const sortSearchCondition = useMemo(() => {
    return SortOptionsByLibrary.filter(({ value }) => value === sort)[0];
  }, [sort]);

  const orderSearchCondition = useMemo(() => {
    return OrderByOptions.filter(({ value }) => value === asc)[0];
  }, [asc]);

  const onOpenMenu = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setButton(event.currentTarget);
  }, []);

  const onCloseMenu = useCallback(() => {
    setButton(null);
  }, []);

  return (
    <>
      <Button className={clsx(classes.sortOptionButton)} onClick={onOpenMenu}>
        <Typography className={clsx(classes.ellipsis)}>
          {orderSearchCondition.name} / {sortSearchCondition.name}
        </Typography>
        <img src={SelectIcon}></img>
      </Button>
      <Popper className={clsx(classes.popper)} open={isOpen} anchorEl={button} transition>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: 'center top',
            }}
          >
            <Paper className={clsx(classes.paper)}>
              <ClickAwayListener onClickAway={onCloseMenu}>
                <MenuList autoFocusItem={isOpen} id="menu-list-grow" onKeyDown={onCloseMenu}>
                  <OrderOptionsByLibrary
                    asc={asc}
                    sort={sort}
                    onClose={onCloseMenu}
                    onChangeAsc={onChangeAsc}
                    onChangeSort={onChangeSort}
                  />
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}

export default LibrarySelect;
